import { StreamPrimitive } from '@squaredup/data-streams';
import { TruncatedText } from 'components/TruncatedText';

interface RawValueProps {
    rawValue: StreamPrimitive;
}

export const RawValue: React.FC<RawValueProps> = ({ rawValue }) => {
    return <TruncatedText title={rawValue?.toString() ?? ''}>{rawValue?.toString() ?? ''}</TruncatedText>;
};
